import React, { Component } from 'react';

import { bool, func, arrayOf, shape } from 'prop-types';
import { withTranslation } from 'react-i18next';
import rehypeRaw from 'rehype-raw';

import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';
import RenderMarkdown from 'components/Common/RenderMarkdown';
import SupportLink from 'components/Common/SupportLink';
import { SUPPORT_URL } from 'config_app';
import withUserType from 'containers/withUserType';

import formatMarkdown from 'modules/WelcomeWidget/utils/formatMarkdown';

// TODO: Fix unused classes which appeared after fixing import syntax

import s from './WelcomeWidgetModal.css';

@withUserType
@withTranslation()
export default class WelcomeWidgetModal extends Component {
  render() {
    const { open, onClose, content, user, t } = this.props;
    return (
      <Dialog
        classes={{
          paper: s.dialogPaper,
        }}
        open={open}
        onClose={() => onClose()}
      >
        <DialogTitle
          classes={{
            root: s.titleRoot,
          }}
          disableTypography
          className={s.title}
        >
          <div className={s.titleActions}>
            <Tabs value="getting-started">
              <Tab
                classes={{ label: s.gettingStartedButton }}
                value="getting-started"
                label={t('WelcomeWidget.WelcomeWidgetModal.GettingStarted')}
              />
            </Tabs>
            {!user.isMember ? (
              <SupportLink
                variant="hyperlink"
                hyperlinkColor="green"
                className={s.supportLink}
                text={
                  <div>
                    {t('WelcomeWidget.WelcomeWidgetModal.HelpCenter')}{' '}
                    <FontAwesomeIcon
                      icon={faCaretDown}
                      color="#6a9b16"
                      rotation={270}
                      className={s.caret}
                    />
                  </div>
                }
                url={SUPPORT_URL}
              />
            ) : null}
          </div>
          <FontAwesomeIcon
            icon={faXmark}
            className={s.close}
            onClick={() => onClose()}
          />
        </DialogTitle>
        <DialogContent classes={{ root: s.contentRoot }}>
          {(content || []).map(entry => (
            <RenderMarkdown
              rehypePlugins={[rehypeRaw]}
              key={entry.content}
              className={s.contentBlock}
            >
              {formatMarkdown(entry.content)}
            </RenderMarkdown>
          ))}
        </DialogContent>
      </Dialog>
    );
  }
}

WelcomeWidgetModal.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  content: arrayOf(shape({})).isRequired,
  user: shape({}),
  t: func.isRequired,
};

WelcomeWidgetModal.defaultProps = {
  user: undefined,
};
